import { createFileRoute, Link } from "@tanstack/react-router";
import { AppHeader } from "../components/AppHeader";
import { t } from "../i18n/en";
import { pageHead } from "../utils/page-title";

export const Route = createFileRoute("/contact")({
  head: () => pageHead("Contact", { canonicalPath: "/contact" }),
  component: ContactPage,
});

function ContactPage() {
  return (
    <main className="relative mx-auto flex min-h-screen w-full max-w-3xl flex-col items-stretch px-4 py-10 sm:px-6 sm:py-14">
      <AppHeader />
      <section className="mt-10 w-full rounded-[2rem] border-[3px] border-black bg-white p-6 shadow-[10px_10px_0_#95A789] sm:p-8">
        <p className="font-mono-display text-xs font-bold uppercase tracking-[0.08em] text-[#6f8065]">
          Contact
        </p>
        <h1 className="harness-page-title mt-3 font-display font-bold lowercase text-black">
          {t("ui.copy_contact_harness_3be9d74f")}
        </h1>
        <p className="mt-6 text-[15px] leading-relaxed text-black/65 sm:text-lg">
          {t("ui.copy_email_questions_at_28765a4c")}{" "}
          <a
            href="mailto:info@megszurgot"
            className="font-semibold text-black underline decoration-[3px] underline-offset-4 transition hover:text-[#6f8065]"
          >
            {t("ui.copy_info_megszurgot_a7b76967")}
          </a>
          .
        </p>
        <p className="mt-8">
          <Link
            to="/"
            className="rounded-full border-2 border-black px-5 py-3 text-sm font-bold uppercase tracking-[0.12em] text-black transition hover:bg-black hover:text-white"
          >
            {t("common.backHome")}
          </Link>
        </p>
      </section>
    </main>
  );
}
